import { render, staticRenderFns } from "./WorkspaceList.vue?vue&type=template&id=74aca24e&scoped=true&lang=pug&"
import script from "./WorkspaceList.vue?vue&type=script&lang=js&"
export * from "./WorkspaceList.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceList.vue?vue&type=style&index=0&id=74aca24e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aca24e",
  null
  
)

export default component.exports